import React,{ useEffect, useState, memo }from 'react';
import PopComponent from "../../../commons/components/Popup/PopupComponent";

import {DropdownButton,Dropdown,FormControl} from "react-bootstrap";

import {CHILDREN_NUMBER} from "../../../commons/constans/children_number";
import CustomYearDropdown from "../../../commons/components/CustomYearDropdown";
import RadioChildGender from "../../../commons/components/RadioChildGender";
import { useUser } from "./../../../commons/customHooks/Account"


const ListChildren = ({
    handleListChildren,
    popupListChildren,
    childrens
}) => {


    const currentYear = new Date().getFullYear();
    const { user } = useUser()

    const [dataChildren,setDataChildren] = useState([{
        id : null,
        age : currentYear,
        gender : 'M'
    }]);

    const handleChangeYear = (year,i) => {
        let children = [...dataChildren];
        children[i].age = year;
        setDataChildren(children);
    }

    const handleChangeGender = (gender,i) => {
        let children = [...dataChildren];
        children[i].gender = gender;
        setDataChildren(children);
    }

    useEffect(() => {
        // console.log('da vao')
        // console.log(user.childrens,'user.childrens')
        if (user?.childrens && user.childrens.length) {
            setDataChildren(user.childrens)
        }
    },[user,popupListChildren]);

    const handleClickRemoveChildren = (index) => {
        let children = [...dataChildren];
        children.splice(index,1);
        setDataChildren(children);
    }

    return (
        <PopComponent
            id={"MD4"}
            show={popupListChildren}
            handleClose={handleListChildren}
            // scrollable={true}
            style={{ backgroundColor: "#faf5fa",maxHeight : 'calc(90vh - 100px)', transform: 'translate(-50%, -55%)' }}
            // csPopupClass={'cs-popup-children'}
            // bodyStyle={{ height: "80vh" }}
            title={"맞춤정보 선택"}
            bodyStyle={{ height: "90vh", padding : '10px' }}
            // csPopupBodyClass={'cs-popup-body-children'}
            headingStyle={{ marginTop : '150px' }}
        >
            <div className={'list-children-content'}>
                {dataChildren.map((info,i) => {
                    return (
                        <div className="information-child m-0 mt-3" key={i}>
                            <div className={'d-flex justify-content-between'}>
                                <p className="information-child__no">{CHILDREN_NUMBER[i]}</p>
                                {dataChildren.length >= 2 ? <img
                                  className={'information-child__icon'}
                                  src="/images/icon_close_black_s.svg"
                                  alt=""
                                  onClick={()=>handleClickRemoveChildren(i)}
                                /> : ''}

                            </div>
                            <div className={'row m-0 p-0'}>
                                    <div className="col-12 information-child__gender__selection p-0 m-0">
                                        <label>
                                            성별
                                        </label>
                                    </div>
                            </div>
                            <RadioChildGender
                                gender={dataChildren[i].gender}
                                handleChange={handleChangeGender}
                                genderIndex={i}
                                classNameBody={'m-0 p-0'}
                            />
                            <div className="information-child__year-of-birth">
                                <p >출생년도</p>
                                <CustomYearDropdown
                                    year={dataChildren[i].age}
                                    handleChange={handleChangeYear}
                                    dropdownIndex={i}
                                />

                            </div>
                        </div>
                    )
                })}
                <div
                    className="add-child-infor m-0 mt-3"
                    onClick={()=> {
                        setDataChildren([
                            ...dataChildren,
                            {
                                id : null,
                                age : currentYear,
                                gender : 'M'
                            }
                        ]);
                    }}
                >
                    <img src="/images/icon_plus-btn.svg" alt="" />
                    <label >아이정보 추가하기</label>
                </div>
                <div className="btn-child-infor m-0 mt-3">
                    <button
                        type="button" className="btn btn-block btn-primary btn-img"
                        onClick={()=>{
                            childrens(dataChildren)
                        }}
                        disabled={dataChildren.length ? false : true}
                    >
                        다음
                    </button>
                </div>
            </div>
        </PopComponent>
    )
}

export default ListChildren;
